import * as z from "zod/v4";
import { ReturnProductSchema } from "../../draft-return/draft-return-items";
import { Provider } from "../../order";
import { ShopifyGraphQLProductSchema as ProductDataSchema } from "../../product";
import { AiReturnReasonSchema } from "./return-reasons";

export const ExchangeRecommendationsSchema = z.array(
  z.object({
    product: ProductDataSchema,
    recommendationMessage: z
      .string()
      .describe(
        "A message explaining why this product is recommended and why it is a good fit for the customer, should be customer facing, max of 2 sentences",
      )
      .optional(),
  }),
);

export const ExchangeHistoryRecommendationsSchema = z.array(
  z.object({ product: ProductDataSchema, exchangeCount: z.number() }),
);

export const GenerateExchangeRecommendationsInputSchema = z.object({
  provider: z.enum(Provider),
  returnedProduct: ReturnProductSchema,
  reasons: z.array(AiReturnReasonSchema),
  aiReturnReasons: z
    .object({
      aiReturnReasonsThreadId: z.string(),
      additionalAiInfo: z.string().optional(),
    })
    .optional(),
  draftReturnId: z.string().optional(),
});

export type GenerateExchangeRecommendationsInput = z.infer<
  typeof GenerateExchangeRecommendationsInputSchema
>;

export type ExchangeRecommendations = z.infer<
  typeof ExchangeRecommendationsSchema
>;

export type ExchangeHistoryRecommendations = z.infer<
  typeof ExchangeHistoryRecommendationsSchema
>;
